import { Flex, Tag } from 'antd';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const ServiceCategoriesSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeCategories } = useNewClientsListContext();

  const { categories } = filtersMap.get(id)!;

  if (categories.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      <Tag
        className={`${PF}__tag`}
        closable
        onClose={() => {
          onChangeCategories([], id);
        }}
      >
        Выбрано: {categories.length} категори
        {categories.length === 1 ? 'я' : categories.length > 4 ? 'й' : 'и'}
      </Tag>
    </Flex>
  );
};
